import { makeStyles } from '@material-ui/core';

import colors from '../../../abstracts/colours';

export const useStyles = makeStyles({
  root: {
    padding: '4px',
  },
  colorPrimary: {
    color: colors.scienceBlue,
    '&:hover': {
      backgroundColor: colors.alabaster,
      color: colors.scienceBlue,
    },
    '&:focus': {
      backgroundColor: colors.gallery,
      color: colors.scienceBlue,
    },
    '&:active': {
      backgroundColor: colors.gallery,
      color: colors.scienceBlue,
    },
  },
  colorInherit: {
    color: 'inherit',
  },
  disabled: {
    color: colors.iron,
  },
});
